import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { useImmer } from "use-immer";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";

import {
  Autocomplete,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";

import { DateTimePicker } from "@mui/x-date-pickers";
import "./BroadcastDialog.css";
import ConfirmBroadcastDialog from "./ConfirmBroadcastDialog";
import "../Components/Components.css";
import mapWATemplate from "../Helper/mapWATemplate";
import renderButtons from "../Helper/renderButtons";
import renderWAPreviewBody from "../Helper/renderWAPreviewBody";
import { getSchemaColumnByTable } from "../Store/Actions/ContactAction";
import { getListAssignment } from "../Store/Actions/OutboundAction";
import { getAllAccount } from "../Store/Actions/TicketAction";

import {
  createBroadcast,
  createBroadcastDetail,
  getWATemplateList,
  sendWAMessageTemplateText,
} from "../Store/Actions/WABAAction";

const BroadcastDialog = ({
  campaignID,
  closeBroadcastContact,
  dataTableID,
  dataTableName,
  isOpen,
  selectedContacts,
  setIsBroadcastDialogShown,
  statusOptions,
}) => {
  const { myInfo } = useSelector((state) => state.auth);

  const initialParams = {
    agentid: myInfo.user.AgentID,
    campaignid: campaignID,
    filter: `contact=|status=|agent=|contactref=|statuscall=`,
    skip: 0,
    take: 999,
    source: 1,
  };

  const [searchParams, setSearchParams] = useState(initialParams);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [isNewLoading, setIsNewLoading] = useState(true);
  const [isByStatusLoading, setIsByStatusLoading] = useState(true);
  const [newContacts, setNewContacts] = useState(0);
  const [byStatusContacts, setByStatusContacts] = useState(0);

  const initialDisplayValues = {
    status: null,
  };

  // Display values for autocomplete components
  const [displayValues, setDisplayValues] = useState(initialDisplayValues);

  const [isLimited, setIsLimited] = useState(false);
  const [limit, setLimit] = useState(null);
  const [contactsToBroadcastAmount, setContactsToBroadcastAmount] = useState(0);

  const [isConfirmBroadcastDialogShown, setIsConfirmBroadcastDialogShown] =
    useState(false);

  const [responseTemplateList, setResponseTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [isSending, setIsSending] = useState(false);

  const initialBroadcastData = {
    name: "",
    schedule: "",
    templateID: "",
    WABAAccountID: "",
  };

  const [broadcastData, setBroadcastData] = useState(initialBroadcastData);
  const [WABAAccounts, setWABAAccounts] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);

  const initialComponentsValues = {
    header: {
      mediaType: "none",
      mediaLink: null,

      attachment: {
        name: null,
        type: null,
        size: null,
        file: null,
      },

      headerText: null,
      headerVariable: null,
      headerVariableName: null,
      headerVariablePreview: null,
    },

    bodyText: "Sample Body Text",
    bodyVariable1: null,
    bodyVariableName1: null,
    bodyVariablePreview1: null,
    bodyVariable2: null,
    bodyVariableName2: null,
    bodyVariablePreview2: null,
    bodyVariable3: null,
    bodyVariableName3: null,
    bodyVariablePreview3: null,
    bodyVariable4: null,
    bodyVariableName4: null,
    bodyVariablePreview4: null,
    bodyVariable5: null,
    bodyVariableName5: null,
    bodyVariablePreview5: null,
    bodyVariable6: null,
    bodyVariableName6: null,
    bodyVariablePreview6: null,
    bodyVariable7: null,
    bodyVariableName7: null,
    bodyVariablePreview7: null,
    bodyVariable8: null,
    bodyVariableName8: null,
    bodyVariablePreview8: null,
    bodyVariable9: null,
    bodyVariableName9: null,
    bodyVariablePreview9: null,
    bodyVariable10: null,
    bodyVariableName10: null,
    bodyVariablePreview10: null,
    footerText: "",
    button: [],
    isCallPermission: false,
  };

  // useImmer used for easier state update
  const [componentsValues, updateComponentsValues] = useImmer(
    initialComponentsValues
  );

  useEffect(() => {
    // If there is selected ticket, choose the selection option and set the ticket amount
    if (selectedContacts.length) {
      setSelectedMethod("selection");
      setContactsToBroadcastAmount(selectedContacts.length);
    }
  }, [selectedContacts.length]);

  // useEffect(() => {
  //   // Initialize display values. useEffect needed because statusOptions is initialized as undefined
  //   statusOptions &&
  //     setDisplayValues({
  //       status: statusOptions?.filter((option) => option.Value !== "5"),
  //     });
  // }, [statusOptions]);

  // Get new contacts
  useEffect(() => {
    setIsNewLoading(true);

    getListAssignment({
      ...searchParams,
      filter: "contact=|status=1|agent=|contactref=|statuscall=",
    })
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("List new ticket", response.data.campaigndatatable[0]);

          setNewContacts(response.data.campaigndatatable[0]);
          setIsNewLoading(false);
        } else {
          console.log("error", response.error);
          setIsNewLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsNewLoading(false);
      });
  }, []);

  // Get Contacts by status
  useEffect(() => {
    setIsByStatusLoading(true);

    // getListAssignment({
    //   ...searchParams,

    //   // If no status is selected, default to new and in progress
    //   filter: searchParams.filter
    //     ? `contact=|status=${value.map((val) => val.Value)}|agent=|contactref=|statuscall=`
    //     : "",
    // })

    getListAssignment(searchParams)
      .then((response) => {
        if (response.status) {
          console.log(
            "List contact by status",
            response.data.campaigndatatable[0]
          );
          setByStatusContacts(response.data.campaigndatatable[0]);
          setIsByStatusLoading(false);
        } else {
          console.log("error", response.error);
          setIsByStatusLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsByStatusLoading(false);
      });
  }, [searchParams.filter]);

  // Get WABA accounts
  useEffect(() => {
    getAllAccount(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          setWABAAccounts(response.data.waba);
        } else {
          toast.error("Error fetching accounts", {
            autoClose: 3000,
          });

          console.log("error", response.error);
        }
      })
      .catch((err) => {
        toast.error("Error fetching accounts", {
          autoClose: 3000,
        });

        console.log("err", err);
      });
  }, []);

  useEffect(() => {
    dataTableID &&
      getSchemaColumnByTable(dataTableID)
        .then((response) => {
          if (response.status) {
            setDataColumns(response.data);
          } else {
            toast.error("Error getting schema columns", { autoClose: 3000 });
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          toast.error("Error getting schema columns", { autoClose: 3000 });
          console.log("err", err);
        });
  }, [dataTableID]);

  // Create template variable components
  function createComponents() {
    let bodyParametersArray = [];

    let componentsArray = [
      {
        type: "header",
        parameters: [],
      },

      {
        type: "body",
        parameters: bodyParametersArray,
      },
    ];

    if (componentsValues.header.headerVariable) {
      componentsArray[0].parameters[0] = {
        type: "ref",
        parameter_name: componentsValues.header.headerVariableName,
        ref_id: componentsValues.header.headerVariable,
      };
    }

    if (componentsValues.header.mediaType === "image" && componentsValues.header.mediaLink) {
      componentsArray[0].parameters.push({
        type: "image",
        image: { link: componentsValues.header.mediaLink }
      });
    }

    if (componentsValues.bodyVariable1) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName1,
        ref_id: componentsValues.bodyVariable1,
      });
    }

    if (componentsValues.bodyVariable2) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName2,
        ref_id: componentsValues.bodyVariable2,
      });
    }

    if (componentsValues.bodyVariable3) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName3,
        ref_id: componentsValues.bodyVariable3,
      });
    }

    if (componentsValues.bodyVariable4) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName4,
        ref_id: componentsValues.bodyVariable4,
      });
    }

    if (componentsValues.bodyVariable5) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName5,
        ref_id: componentsValues.bodyVariable5,
      });
    }

    if (componentsValues.bodyVariable6) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName6,
        ref_id: componentsValues.bodyVariable6,
      });
    }

    if (componentsValues.bodyVariable7) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName7,
        ref_id: componentsValues.bodyVariable7,
      });
    }

    if (componentsValues.bodyVariable8) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName8,
        ref_id: componentsValues.bodyVariable8,
      });
    }

    if (componentsValues.bodyVariable9) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName9,
        ref_id: componentsValues.bodyVariable9,
      });
    }

    if (componentsValues.bodyVariable10) {
      bodyParametersArray.push({
        type: "ref",
        parameter_name: componentsValues.bodyVariableName10,
        ref_id: componentsValues.bodyVariable10,
      });
    }

    return componentsArray;
  }

  function closeAfterBroadcast() {
    setIsConfirmBroadcastDialogShown(false);
    setIsBroadcastDialogShown(false);
    closeBroadcastContact();
  }

  // Format phone number
  function formatPhoneNumber(number) {
    // If it begins with "0" replace it with "62"
    if (number.charAt(0) === "0") {
      number = "62" + number.slice(1);
    }

    // If it begins with "+" remove it
    if (number.charAt(0) === "+") {
      number.slice(1);
    }

    return number;
  }

  async function sendBroadcastMessage() {
    setIsSending(true);

    let success = 0,
      failed = 0;

    const promises = selectedContacts.map((contact) => {
      let phoneNumber = contact.split("-")[1];

      // Format phone number. If it begins with "0" replace it with "62"
      if (phoneNumber.charAt(0) === "0") {
        phoneNumber = "62" + phoneNumber.slice(1);
      }

      return sendWAMessageTemplateText({
        recipientphoneno: phoneNumber,

        template: {
          name: selectedTemplate.TemplateName,
          language: { code: selectedTemplate.Language },
          components: createComponents(),
        },

        wabaaccountid: broadcastData.WABAAccountID,
      })
        .then((response) => {
          if (response.status) {
            success += 1;
          } else {
            console.log(`error sending to ${phoneNumber}`, response.error);
            failed += 1;
          }
        })
        .catch((err) => {
          console.log(`error sending to ${phoneNumber}`, err);
          failed += 1;
        });
    });

    await Promise.all(promises);

    toast.info(
      <>
        <p>Broadcast message sent.</p>

        <p>
          {success} contacts success, {failed} failed.
        </p>
      </>,
      {
        autoClose: 5000,
      }
    );

    closeAfterBroadcast();
    setIsSending(false);
  }

  function createBroadcastSchedule() {
    setIsSending(true);

    createBroadcast({
      waba_accountid: broadcastData.WABAAccountID
        ? broadcastData.WABAAccountID
        : "0",

      broadcasttime: broadcastData.schedule
        ? broadcastData.schedule
        : moment().toISOString(true),

      broadcastname: broadcastData.name,
      waba_templateid: broadcastData.templateID,

      components: {
        template: {
          name: selectedTemplate.TemplateName,
          language: { code: selectedTemplate.Language },
          components: createComponents(),
        },
      },

      sourceby: "contact", // contact || campaign
      tableid: dataTableID,
    })
      .then((response) => {
        if (response.status) {
          console.log(response.data);

          createBroadcastDetail({
            broadcastdetail: selectedContacts.map((contact) => {
              return {
                broadcastid: response.data,
                contactid: contact.split("-")[0],
                recipientwaid: formatPhoneNumber(contact.split("-")[1]),
                datatablerecid: contact.split("-")[2],
              };
            }),
          })
            .then((response) => {
              if (response.status) {
                toast.info(
                  <>
                    {broadcastData.schedule ? (
                      <>
                        <p>Broadcast schedule {broadcastData.name} created.</p>

                        <p>
                          {selectedContacts.length} contacts scheduled for{" "}
                          {moment(broadcastData.schedule).format(
                            "dddd, D MMMM YYYY [at] HH:mm"
                          )}
                          .
                        </p>
                      </>
                    ) : (
                      <p>Broadcast message {broadcastData.name} created.</p>
                    )}
                  </>,

                  {
                    autoClose: 5000,
                  }
                );

                setIsSending(false);
                closeAfterBroadcast();
              } else {
                console.log("error create broadcast", response.error);
                setIsSending(false);

                toast.error("error create broadcast", {
                  autoClose: 5000,
                });
              }
            })
            .catch((err) => {
              console.log("error create broadcast", err);
              setIsSending(false);

              toast.error("error create broadcast", {
                autoClose: 5000,
              });
            });
        } else {
          console.log("error create broadcast", response.error);
          setIsSending(false);

          toast.error("error create broadcast", {
            autoClose: 5000,
          });
        }
      })
      .catch((err) => {
        console.log("error create broadcast", err);
        setIsSending(false);

        toast.error("error create broadcast", {
          autoClose: 5000,
        });
      });
  }

  const handleClose = () => {
    setSearchParams(initialParams);
    setSelectedMethod("");
    setDisplayValues(initialDisplayValues);
    setIsLimited(false);
    setLimit(null);
    setContactsToBroadcastAmount(0);
    setSelectedTemplate({});
    setIsBroadcastDialogShown(false);
    setBroadcastData(initialBroadcastData);
  };

  const validateNextButton = () => {
    if (currentStep === 1) {
      if (
        contactsToBroadcastAmount <= 0 ||
        !selectedTemplate.ID ||
        !broadcastData.WABAAccountID ||
        !broadcastData.name
      ) {
        return true;
      } else {
        return false;
      }
    }

    if (currentStep === 2) {
      // Checks for any empty variable
      if (componentsValues.parameterFormat === "named") {
        const hasEmptyHeaderVariable =
          /\{\{[^}]+\}\}/.test(componentsValues.header.headerText ?? "") &&
          !componentsValues.header.headerVariable;

        // Find all {{...}} patterns in bodyText
        const matches = componentsValues.bodyText.match(/\{\{[^}]+\}\}/g) || [];

        // Check if any matched variable has an empty value
        const hasEmptyBodyVariable = matches.some((placeholder, index) => {
          const variableValue = componentsValues[`bodyVariable${index + 1}`];
          return !variableValue; // placeholder exists but value is empty
        });

        if (hasEmptyHeaderVariable || hasEmptyBodyVariable) {
          return true;
        }
      } else {
        if (
          (componentsValues.header.headerText?.includes("{{1}}") &&
            !componentsValues.header.headerVariable) ||
          (componentsValues.bodyText?.includes("{{1}}") &&
            !componentsValues.bodyVariable1) ||
          (componentsValues.bodyText?.includes("{{2}}") &&
            !componentsValues.bodyVariable2) ||
          (componentsValues.bodyText?.includes("{{3}}") &&
            !componentsValues.bodyVariable3) ||
          (componentsValues.bodyText?.includes("{{4}}") &&
            !componentsValues.bodyVariable4) ||
          (componentsValues.bodyText?.includes("{{5}}") &&
            !componentsValues.bodyVariable5) ||
          (componentsValues.bodyText?.includes("{{6}}") &&
            !componentsValues.bodyVariable6) ||
          (componentsValues.bodyText?.includes("{{7}}") &&
            !componentsValues.bodyVariable7) ||
          (componentsValues.bodyText?.includes("{{8}}") &&
            !componentsValues.bodyVariable8) ||
          (componentsValues.bodyText?.includes("{{9}}") &&
            !componentsValues.bodyVariable9) ||
          (componentsValues.bodyText?.includes("{{10}}") &&
            !componentsValues.bodyVariable10)
        ) {
          return true;
        }
      }
    }

    return false;
  };

  /* function renderBodyVariableTextfields() {
    const variablesCount = 10;
    const variables = Array.from({ length: variablesCount }, (_, i) => i + 1);

    return (
      <>
        {variables.map(
          (num) =>
            componentsValues.bodyText.includes(`{{${num}}}`) && (
              <TextField
                key={num}
                label={`Body variable ${num}`}
                required
                select
                value={componentsValues[`bodyVariable${num}`]}
                onChange={(e) => {
                  updateComponentsValues((draft) => {
                    draft[`bodyVariable${num}`] = e.target.value;
                  });
                }}
              >
                {dataColumns ? (
                  dataColumns.map((dataColumn) => {
                    return (
                      <MenuItem
                        key={dataColumn.DataColumnID}
                        value={dataColumn.DataColumnID}
                        onClick={() =>
                          updateComponentsValues((draft) => {
                            draft[
                              `bodyVariablePreview${num}`
                            ] = `[${dataColumn.DataColumnName}]`;
                          })
                        }
                      >
                        {dataColumn.DataColumnName}
                      </MenuItem>
                    );
                  })
                ) : (
                  <MenuItem value="0" disabled>
                    Loading...
                  </MenuItem>
                )}
              </TextField>
            )
        )}
      </>
    );
  } */

  function renderBodyVariableTextFields() {
    let textFields = [];

    if (componentsValues.parameterFormat === "named") {
      // Find all instances of named variables in the text
      const variables = [
        ...componentsValues.bodyText.matchAll(/\{\{([^}]+)\}\}/g),
      ];

      variables.forEach((match, index) => {
        const key = `bodyVariable${index + 1}`;

        textFields.push(
          <TextField
            key={index + 1}
            label={match[1]}
            required
            select
            value={componentsValues[key]}
            onChange={(e) => {
              updateComponentsValues((draft) => {
                draft[key] = e.target.value;
                draft[`bodyVariableName${index + 1}`] = match[1];
              });
            }}
          >
            {dataColumns ? (
              dataColumns.map((dataColumn) => {
                return (
                  <MenuItem
                    key={dataColumn.DataColumnID}
                    value={dataColumn.DataColumnID}
                    onClick={() =>
                      updateComponentsValues((draft) => {
                        draft[
                          `bodyVariablePreview${index + 1}`
                        ] = `[${dataColumn.DataColumnName}]`;
                      })
                    }
                  >
                    {dataColumn.DataColumnName}
                  </MenuItem>
                );
              })
            ) : (
              <MenuItem value="0" disabled>
                Loading...
              </MenuItem>
            )}
          </TextField>
        );
      });
    } else {
      // Find all instances of "{{n}}" in the text
      const variables = [
        ...componentsValues.bodyText.matchAll(/\{\{(\d+)\}\}/g),
      ].map((match) => Number(match[1]));

      variables.forEach((num) => {
        const key = `bodyVariable${num}`;

        textFields.push(
          <TextField
            key={num}
            label={`Body variable ${num}`}
            required
            select
            value={componentsValues[key]}
            onChange={(e) => {
              updateComponentsValues((draft) => {
                draft[key] = e.target.value;
              });
            }}
          >
            {dataColumns ? (
              dataColumns.map((dataColumn) => {
                return (
                  <MenuItem
                    key={dataColumn.DataColumnID}
                    value={dataColumn.DataColumnID}
                    onClick={() =>
                      updateComponentsValues((draft) => {
                        draft[
                          `bodyVariablePreview${num}`
                        ] = `[${dataColumn.DataColumnName}]`;
                      })
                    }
                  >
                    {dataColumn.DataColumnName}
                  </MenuItem>
                );
              })
            ) : (
              <MenuItem value="0" disabled>
                Loading...
              </MenuItem>
            )}
          </TextField>
        );
      });
    }

    return textFields;
  }

  function renderWAPreviewHeader() {
    if (componentsValues.parameterFormat === "named") {
      return componentsValues.header.headerText?.replace(
        /\{\{[^}]+\}\}/g,
        componentsValues.header.headerVariablePreview
          ? componentsValues.header.headerVariablePreview
          : `{{${componentsValues.header.headerVariableName}}}`
      );
    } else {
      return componentsValues.header.headerText?.replace(
        "{{1}}",
        componentsValues.header.headerVariablePreview
          ? componentsValues.header.headerVariablePreview
          : "{{1}}"
      );
    }
  }

  function extractHeaderVariableName() {
    const matchedPattern =
      componentsValues.header.headerText.match(/\{\{([^}]+)\}\}/);

    if (matchedPattern) {
      return matchedPattern[1];
    }
  }

  return (
    <Dialog
      open={isOpen}
      className="dialog broadcast-dialog"
      fullWidth
      maxWidth="lg"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <h2 className="title">
            {dataTableName ? `Broadcast - ${dataTableName}` : "Broadcast"}
          </h2>

          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>

          {currentStep === 1 && (
            <>
              <div className="text-fields">
                <TextField
                  className="text-field-item"
                  label="Broadcast Name"
                  value={broadcastData.name}
                  onChange={(e) => {
                    setBroadcastData({
                      ...broadcastData,
                      name: e.target.value,
                    });
                  }}
                />

                <TextField
                  className="text-field-item"
                  label="WABA Account"
                  select
                  value={broadcastData.WABAAccountID}
                  onChange={(e) => {
                    setBroadcastData({
                      ...broadcastData,
                      WABAAccountID: e.target.value,
                    });

                    getWATemplateList(e.target.value)
                      .then((response) => {
                        if (response.status) {
                          setResponseTemplateList(response.data);
                        } else {
                          console.log("error", response.error);

                          toast.error("Error fetching templates", {
                            autoClose: 3000,
                          });
                        }
                      })
                      .catch((err) => {
                        console.log("err", err);

                        toast.error("Error fetching templates", {
                          autoClose: 3000,
                        });
                      });
                  }}
                >
                  {WABAAccounts?.map((account) => (
                    <MenuItem key={account.ID} value={account.ID}>
                      {account.Name}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  className="text-field-item"
                  label="Template"
                  select
                  value={broadcastData.templateID}
                >
                  {responseTemplateList.length ? (
                    responseTemplateList.map((template) => (
                      <MenuItem
                        disabled={template.Status !== "APPROVED"}
                        key={template.ID}
                        value={template.ID}
                        onClick={() => {
                          setBroadcastData({
                            ...broadcastData,
                            templateID: template.ID,
                          });

                          setSelectedTemplate(template);

                          updateComponentsValues((draft) =>
                            mapWATemplate(draft, template)
                          );
                        }}
                      >
                        {template.TemplateName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No template found.</MenuItem>
                  )}
                </TextField>

                <DateTimePicker
                  ampm={false}
                  className="text-field-item"
                  label="Schedule"
                  minDateTime={moment()}
                  renderInput={(params) => <TextField {...params} />}
                  // value={
                  //   broadcastData.schedule
                  //     ? moment(broadcastData.schedule)
                  //     : moment()
                  // }
                  onChange={(value) => {
                    setBroadcastData({
                      ...broadcastData,
                      schedule: value.toISOString(true),
                    });
                  }}
                />
              </div>

              <div className="method-list">
                {selectedContacts.length ? (
                  <div
                    className={`method selection ${
                      selectedMethod === "selection" ? "selected" : ""
                    }`}
                    onClick={() => {
                      setSelectedMethod("selection");
                      setContactsToBroadcastAmount(selectedContacts.length);
                    }}
                  >
                    <Icon height="34" icon="ci:select-multiple" />

                    <div className="name-selected">
                      <p className="method-name">Set Selected</p>

                      <p className="selected-amount">
                        {selectedContacts?.length} Contact Selected
                      </p>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {statusOptions && (
                  <>
                    <div
                      className={`method new ${
                        selectedMethod === "new" ? "selected" : ""
                      }`}
                      onClick={() => {
                        setSelectedMethod("new");
                        setContactsToBroadcastAmount(newContacts.length);
                      }}
                    >
                      <Icon
                        height="34"
                        icon="material-symbols:fiber-new-outline"
                      />

                      <div className="name-selected">
                        <p className="method-name">Select All New</p>

                        <p className="selected-amount">
                          {isNewLoading
                            ? "Loading..."
                            : `${newContacts.length} Contact Selected`}
                        </p>
                      </div>
                    </div>

                    <div
                      className={`method by-status ${
                        selectedMethod === "byStatus" ? "selected" : ""
                      }`}
                      onClick={() => {
                        setSelectedMethod("byStatus");
                        setContactsToBroadcastAmount(byStatusContacts.length);
                      }}
                    >
                      <Icon height="34" icon="mingcute:filter-2-fill" />

                      <div className="name-selected">
                        <p className="method-name">Select by Status</p>

                        <p className="selected-amount">
                          {isByStatusLoading
                            ? "Loading..."
                            : `${byStatusContacts.length} Ticket Selected`}
                        </p>
                      </div>

                      <Autocomplete
                        className="search-item status-selector"
                        disableClearable
                        // filterSelectedOptions
                        // multiple
                        // Hide Completed option
                        options={statusOptions}
                        value={displayValues.status}
                        getOptionLabel={(status) => status.Text}
                        onChange={(event, value) => {
                          setSearchParams({
                            ...searchParams,

                            // filter: value.length
                            //   ? `contact=|status=${value.map(
                            //       (val) => val.Value
                            //     )}|agent=|contactref=|statuscall=`
                            //   : "",

                            filter: `contact=|status=${value.Value}|agent=|contactref=|statuscall=`,
                          });

                          setDisplayValues({
                            ...displayValues,
                            status: value,
                          });

                          console.log("displayValues", displayValues);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Status" />
                        )}
                      />
                    </div>
                  </>
                )}
              </div>
            </>
          )}

          {currentStep === 2 && (
            <div
              className={`preview-step ${
                // componentsValues.header.headerText?.includes("{{1}}") ||
                // componentsValues.bodyText.includes("{{1}}")
                /\{\{[^}]+\}\}/.test(
                  componentsValues.header.headerText ?? ""
                ) || /\{\{[^}]+\}\}/.test(componentsValues.bodyText)
                  ? "has-variables"
                  : ""
              }`}
            >
              {/* {(componentsValues.header.headerText?.includes("{{1}}") ||
                componentsValues.bodyText.includes("{{1}}")) && ( */}
              {(/\{\{[^}]+\}\}/.test(
                componentsValues.header.headerText ?? ""
              ) ||
                /\{\{[^}]+\}\}/.test(componentsValues.bodyText)) && (
                <section className="form">
                  <p className="title">Set Variables</p>

                  {/* {componentsValues.header.headerText?.includes("{{1}}") && ( */}
                  {/\{\{[^}]+\}\}/.test(
                    componentsValues.header.headerText ?? ""
                  ) && (
                    <TextField
                      label={
                        componentsValues.parameterFormat === "named"
                          ? extractHeaderVariableName()
                          : "Header variable"
                      }
                      placeholder="Please select"
                      required
                      select
                      value={componentsValues.header.headerVariable}
                      onChange={(e) => {
                        updateComponentsValues((draft) => {
                          draft.header.headerVariable = e.target.value;
                        });
                      }}
                    >
                      {dataColumns ? (
                        dataColumns.map((dataColumn) => {
                          return (
                            <MenuItem
                              key={dataColumn.DataColumnID}
                              value={dataColumn.DataColumnID}
                              onClick={() =>
                                updateComponentsValues((draft) => {
                                  draft.header.headerVariablePreview = `[${dataColumn.DataColumnName}]`;
                                })
                              }
                            >
                              {dataColumn.DataColumnName}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem value="0" disabled>
                          Loading...
                        </MenuItem>
                      )}
                    </TextField>
                  )}

                  {renderBodyVariableTextFields()}
                </section>
              )}

              <section
                className={`preview-screen-container ${
                  // componentsValues.header.headerText?.includes("{{1}}") ||
                  // componentsValues.bodyText.includes("{{1}}")
                  /\{\{[^}]+\}\}/.test(
                    componentsValues.header.headerText ?? ""
                  ) || /\{\{[^}]+\}\}/.test(componentsValues.bodyText)
                    ? "has-variables"
                    : ""
                }`}
              >
                <p className="title">Preview</p>

                <div className="preview-screen">
                  <div
                    className={`preview-message ${
                      componentsValues.button.length ? "has-buttons" : ""
                    }`}
                  >
                    {componentsValues.header.headerText && (
                      <header>{renderWAPreviewHeader()}</header>
                    )}

                    <p
                      dangerouslySetInnerHTML={{
                        __html: renderWAPreviewBody(
                          componentsValues,
                          componentsValues.bodyText,
                          true,
                          componentsValues.parameterFormat
                        ),
                      }}
                    />

                    {componentsValues.footerText && (
                      <footer>{componentsValues.footerText}</footer>
                    )}

                    <p className="time">{moment().format("HH:mm")}</p>

                    <div className="button-container">
                      {renderButtons(componentsValues.button)}
                    </div>
                  </div>

                  {componentsValues.isCallPermission && (
                    <div className="preview-message call-permission">
                      <div className="text-container">
                        <div>
                          <div className="call-icon">
                            <Icon height="24" icon="material-symbols:call" />
                          </div>

                          <p className="body-text">
                            Can [Business Name] call you?
                          </p>
                        </div>

                        <p className="time">{moment().format("HH:mm")}</p>
                      </div>

                      <div className="preference">
                        <p>Choose preference</p>
                        <Icon height="18" icon="mingcute:down-fill" />
                      </div>
                    </div>
                  )}
                </div>
              </section>
            </div>
          )}

          <div className="steps-indicator">
            <div className={`indicator ${currentStep === 1 ? "active" : ""}`} />
            <div className={`indicator ${currentStep === 2 ? "active" : ""}`} />
          </div>
        </div>

        <section className="limit">
          {currentStep === 1 ? (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isLimited}
                    onChange={(e) => setIsLimited(e.target.checked)}
                  />
                }
                label="Limit Result to"
              />

              <TextField
                disabled={!isLimited}
                type="number"
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value);
                  setContactsToBroadcastAmount(e.target.value);
                }}
              />
            </>
          ) : (
            <p>Selected {contactsToBroadcastAmount} Contact</p>
          )}
        </section>

        <section className="buttons">
          <button
            className="cancel"
            type="button"
            onClick={() => {
              currentStep === 1
                ? handleClose()
                : setCurrentStep(currentStep - 1);
            }}
          >
            {currentStep === 1 ? "Cancel" : "Prev"}
          </button>

          <button
            className="confirm"
            disabled={validateNextButton()}
            type="submit"
            onClick={() => {
              currentStep === 1
                ? setCurrentStep(currentStep + 1)
                : setIsConfirmBroadcastDialogShown(true);
            }}
          >
            {currentStep === 1 ? "Next" : "Confirm"}
          </button>
        </section>
      </div>

      <ConfirmBroadcastDialog
        contactAmount={contactsToBroadcastAmount}
        createSchedule={createBroadcastSchedule}
        isOpen={isConfirmBroadcastDialogShown}
        isSending={isSending}
        schedule={broadcastData.schedule}
        send={sendBroadcastMessage}
        setIsConfirmBroadcastDialogShown={setIsConfirmBroadcastDialogShown}
      />
    </Dialog>
  );
};

export default BroadcastDialog;
